import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { DropdownItem } from './dropdown-v2.interface';

@Component({
  selector: 'app-dropdown-v2',
  templateUrl: './dropdown-v2.component.html',
  styleUrls: ['./dropdown-v2.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DropdownV2Component),
      multi: true,
    },
  ],
})
export class DropdownV2Component implements ControlValueAccessor, OnInit {
  @Input() items: DropdownItem[] = [];
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() isTranslate: boolean = true;
  @Input() control!: FormControl;
  @Output() onValueChange = new EventEmitter<any>();

  @ViewChild('selectRef') selectRef!: MatSelect;

  value: any;

  onChange = (_: any) => {};
  onTouched = () => {};

  ngOnInit(): void {}

  writeValue(value: any): void {
    this.value = value;
    this.control.setValue(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
    this.control.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onSelectionChange(value: any) {
    this.onChange(value);
    this.onValueChange.emit(value);
  }
}
